import React from 'react'
import { UploadComprehensiveAssessmentFormStyle } from './styled'
import {
  Button,
  Image,
  InputUpload,
  Section,
  InputTextarea,
} from '../../components'
import { ICONS } from '../../themes'

import { ROUTE_PATH, redirect, STRING } from '../../helpers'

export class UploadComprehensiveAssessmentFormContainer extends React.Component {
  render() {
    return (
      <UploadComprehensiveAssessmentFormStyle>
        {/* PAGE TITLE
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="page-topbar">
          <Section className="page-header">
            <Section className="page-icon">
              <Image
                src={ICONS['icon-check-list-checked-white.svg']}
                alt="page icon"
              />
            </Section>

            <Section className="title-and-breadcrumb">
              <Section className="title">
                {STRING.COMPREHENSIVE_ASSESSMENT_MANAGEMENT}
              </Section>

              <Section className="breadcrumbs">
                <Button
                  className="breadcrumb"
                  onClick={() => {
                    this.props.history.push(ROUTE_PATH.HOME.LINK)
                  }}
                >
                  <span>{STRING.HOME}</span>
                </Button>

                <Button className="breadcrumb current">
                  <span>{STRING.COMPREHENSIVE_ASSESSMENT_MANAGEMENT}</span>
                </Button>
              </Section>
            </Section>
          </Section>
        </Section>

        {/* PAGE CONTENT
        -----------------------------------------------------
        -----------------------------------------------------
        */}
        <Section className="main-content form">
          <Section className="content-body">
            <Section className="form-wrapper">
              <Section className="form-group-title">
                Upload Online Comprehensive : Manufacturer
              </Section>

              <Section className="form-group is-error">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <InputUpload id="upload" />
                    <Button className="theme-blue">Upload</Button>
                  </Section>

                  <Section className="message">error</Section>
                </Section>
              </Section>

              <a className="file-download-link" href="#">
                Download Template
              </a>

              <Section className="form-group">
                <Section className="form-group-control">
                  <Section className="form-group-inner-wrapper">
                    <div className="upload-log-outter-wrapper">
                      <div className="upload-log-wrapper">
                        <span className="error">
                          Row 12 of TaxID is in the wrong format
                        </span>
                        <br />
                        <span className="success">
                          Row 12 of TaxID is in the wrong format
                        </span>
                        <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                        Row 12 of TaxID is in the wrong format <br />
                        Row 25 of Email must not be null
                        <br />
                      </div>
                    </div>
                  </Section>
                </Section>
              </Section>
            </Section>

            <Section className="form-actions">
              <Button className="theme-border-gray">Cancel</Button>
            </Section>
          </Section>
        </Section>
      </UploadComprehensiveAssessmentFormStyle>
    )
  }
}
